import { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { SheetComp } from 'design-system/ui/atoms/sheet'

import { getInternalActionExecutionLogById } from '~/generated/client'
import { ActionHeaderBlock } from './blocks/actionsHeader'
import { ConnectionBlock } from './blocks/connectionBlock'
import { ActionResultBlock } from './blocks/endResultBlock'
import { LogHeaderStart } from './blocks/header'
import { NetworkNLogsBlock } from './blocks/networkNLogsBlock'

export const LogsSheet = ({
  open = true,
  setOpen,
  actionLogId,
}: {
  open: boolean
  setOpen: (open: boolean) => void
  actionLogId: string
}) => {
  const { data: logData } = useQuery({
    queryKey: ['actionLog', actionLogId],
    queryFn: () => getInternalActionExecutionLogById({ id: actionLogId }),
  })
  const [styleSheet, setStyle] = useState<React.CSSProperties>({})

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        setStyle({
          transform: 'translateX(0px)',
        })
      }, 50)
    } else {
      setTimeout(() => {
        setStyle({
          transform: 'translateX(100%)',
        })
      }, 100)
    }
  }, [open])

  return (
    <SheetComp
      className=" max-h-[100vh] min-w-[626px] bg-white  p-[0px]"
      style={styleSheet}
      closeIconClassName="top-[16px] right-[16px] hidden"
      open={open}
      onOpenChange={() => setOpen(false)}
    >
      <div className="max-h-[100vh] overflow-y-scroll p-[8px] pb-0 pl-[8px] ">
        {/* @TODO (@CryogenicPlanet) - when log data is not there show skeleton */}
        <LogHeaderStart data={logData!} />
        <div className="ds-px-12 ds-border-b ds-border-gray-200 pl-16px relative mt-11 min-h-[calc(100vh-92px)] pl-[44px]">
          <div
            id="line"
            className="ds-bg-white-300/60 ds-z-10 absolute left-[28px] top-[-46px] h-[calc(100%+46px)] w-[1px] "
          ></div>
          <div className="ds-flex ds-flex-col gap-[48px]">
            {logData && <ActionHeaderBlock data={logData} />}
            {logData
              ? logData.steps.map((step, index) =>
                  step.type === 'fetch_connection_details' ? (
                    <ConnectionBlock
                      data={step}
                      key={index}
                      connectionId={logData.connection.id || ''}
                    />
                  ) : (
                    <NetworkNLogsBlock data={step} key={index} />
                  ),
                )
              : null}
            {logData && <ActionResultBlock logData={logData} />}
          </div>
        </div>
      </div>
    </SheetComp>
  )
}
